import { useEffect } from 'react';
import { selectCanvasAutoTab } from '../../projection/canvas/canvasTabsSelector.js';

export function useCanvasAutoTabEffect(options) {
  const {
    canvasActiveTabKey,
    canvasEvidenceItems,
    canvasFocusEvidenceAnchorId,
    canvasTabs,
    artifactTabProjection,
    hasCanvasAnalysisPayload,
    hasRetrievalEvidenceRows,
    hasSourcingCanvasState,
    setCanvasActiveTabKey,
    showCanvasPanel,
  } = {
    canvasEvidenceItems: [],
    canvasFocusEvidenceAnchorId: '',
    canvasTabs: [],
    hasCanvasAnalysisPayload: false,
    hasRetrievalEvidenceRows: false,
    hasSourcingCanvasState: false,
    showCanvasPanel: false,
    ...options,
  };
  useEffect(() => {
    const nextAutoTab = selectCanvasAutoTab({
      canvasEvidenceItems,
      canvasTabs,
      artifactTabProjection,
      hasSourcingCanvasState,
      hasCanvasAnalysisPayload,
      canvasFocusEvidenceAnchorId,
      showCanvasPanel,
      canvasActiveTabKey,
      hasRetrievalEvidenceRows,
    });
    if (nextAutoTab && nextAutoTab !== canvasActiveTabKey) {
      setCanvasActiveTabKey(nextAutoTab);
    }
  }, [
    canvasActiveTabKey,
    canvasEvidenceItems,
    canvasFocusEvidenceAnchorId,
    canvasTabs,
    artifactTabProjection,
    hasCanvasAnalysisPayload,
    hasRetrievalEvidenceRows,
    hasSourcingCanvasState,
    setCanvasActiveTabKey,
    showCanvasPanel,
  ]);
}

export default useCanvasAutoTabEffect;
